export const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export function isUuid(value) {
    return UUID_REGEX.test(value);
}
/**
 * A v4 UUID on ANY context. `crypto.randomUUID()` is secure-context-only
 * (https, localhost); a page served over plain http (a LAN dev API, a phone
 * on the office network, the team-concurrency harness's vantage) has
 * `getRandomValues` but not `randomUUID`, and a bare call throws inside the
 * handler that reached for it. Measured 2026-09-02: the team-review
 * CommentThread cleared the box and posted nothing, with the rejection
 * surfacing nowhere. Prefer the platform UUID when it exists.
 */
export function newUuid() {
    const c = globalThis.crypto;
    if (c && typeof c.randomUUID === 'function')
        return c.randomUUID();
    const bytes = new Uint8Array(16);
    if (c && typeof c.getRandomValues === 'function') {
        c.getRandomValues(bytes);
    }
    else {
        for (let i = 0; i < 16; i++)
            bytes[i] = Math.floor(Math.random() * 256);
    }
    bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
    bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10xx
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
//# sourceMappingURL=uuid.js.map